import React, { FC } from 'react';
import { AptorApi } from '../../../../../../Api';
import { Notes } from '../../../../Components/OverviewNotes';
import { ICompanyUnitLaw } from '.';

interface IProps {
  lawId: number;
  companyUnits: ICompanyUnitLaw[];
  onChange: (state: { companyUnits: ICompanyUnitLaw[] }) => void;
}

export const LawNotes: FC<IProps> = ({ lawId, companyUnits, onChange }) => {
  const editLawNote = (companyUnitIds: number[], note: string | null, api: AptorApi, onSuccess: () => void) =>
    api.updateLawPortalLawNote(lawId, companyUnitIds, note).then(() => {
      if (api.abortController?.signal.aborted) {
        return;
      }
      onSuccess();
      var updatedCompanyUnits = companyUnits.replace(
        (x) => companyUnitIds.includes(x.id),
        (item) => ({ ...item, ...{ note } }),
      );
      onChange({ companyUnits: updatedCompanyUnits });
    });

  return <Notes companyUnits={companyUnits} editNote={editLawNote} />;
};
